import { Injectable } from '@angular/core';
import { ThemeService } from 'rev-portal/branding/Theme.Service';
import { BehaviorSubject, combineLatest, debounceTime, map, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
//Stores height and other layout info of main nav header to be used in layout calculations elsewhere.
export class MainHeaderPositionService {
	private readonly heightSubject$ = new BehaviorSubject<number>(undefined);
	private readonly transparencyActiveSubject$ = new BehaviorSubject<boolean>(false);

	public transparencyActive$: Observable<boolean> = this.transparencyActiveSubject$.asObservable();

	public readonly height$: Observable<number> = combineLatest([
		this.heightSubject$.asObservable(),
		this.transparencyActiveSubject$.asObservable(),
		this.ThemeService.brandingSettings$
	])
		.pipe(
			map(([val, isTransparencyActive, brandingSettings]) => {
				const bannerHeight = brandingSettings.headerSettings.bannerImageUri ? brandingSettings.headerSettings.bannerImageHeight : 0;
				return isTransparencyActive ? bannerHeight : val
			})
		);

	public isTransparencyActive: boolean;
	public isTransparencySupported: boolean;

	constructor(private readonly ThemeService: ThemeService) { }

	public get height(): number {
		return this.heightSubject$.getValue();
	}

	public get layoutHeight(): number {
		return this.isTransparencyActive ? 0 : this.height;
	}

	public setHeight(h: number): void {
		this.heightSubject$.next(h);
	}

	public setTransparency(isActive: boolean): void {
		if (this.isTransparencyActive !== isActive) {
			this.transparencyActiveSubject$.next(isActive);
		}

		//backward compatibility for now.
		this.isTransparencyActive = isActive;
	}
}
